"use strict";

/* global $ */
if (window.NodeList && !NodeList.prototype.forEach) {
    NodeList.prototype.forEach = Array.prototype.forEach;
}

document.addEventListener('DOMContentLoaded', function () {
    let openControl = null;

    function closeOpenControl () {
        if (openControl !== null) {
            openControl.button.setAttribute('aria-expanded', 'false');
            openControl.content.setAttribute('aria-hidden', 'true');
            openControl = null;
        }
    }

    document.querySelectorAll('.js-controls-toggle').forEach(function (select) {
        select.addEventListener('click', function () {
            if (!this.getAttribute('aria-controls')) {
                return;
            }

            var target = document.querySelector('#' + this.getAttribute('aria-controls'));

            if (typeof target === 'undefined') {
                return;
            }

            const isExpanded = this.getAttribute('aria-expanded') === 'true';

            if (openControl !== null) {
                closeOpenControl();
            }

            this.setAttribute('aria-expanded', String(!isExpanded));
            target.setAttribute('aria-hidden', String(isExpanded));

            openControl = !isExpanded ? {button: this, content: target} : null;
        });
    });

    document.addEventListener('click', function (event) {
        let target = event.target;

        if (openControl === null) {
            return;
        }

        while (target) {
            if (target.classList.contains('js-custom-select')) {
                break;
            }
            target = target.parentNode;
            if (target.tagName === 'BODY') {
                target = null;
                break;
            }
        }

        if (target === null) {
            closeOpenControl();
        }
    });

    const $filter = $('.js-filter');
    const $filterSelected = $('.js-filter-selected-options');
    const $inputs = $filter.find('input[type="checkbox"]');
    const filter = {};
    const $resultItems = $('.js-filter-result-item');

    $inputs.each(function (index, input) {
        input.addEventListener('change', filterRender);
    });

    $filter.on('click', '.js-filter-selected-option', function () {
        const $input = $filter.find('input[name="' + this.dataset.name + '"]');
        $input.prop('checked', !$input.prop('checked'));
        updateFilterData();
    });

    function updateFilterData() {
        $inputs.each(function (index, input) {
            const $input = $(input);
            const nameData = input.getAttribute('name').split('-');

            if (nameData.length !== 3) {
                throw new Error('некорректно указано значение атрибута name');
            }

            if (!filter.hasOwnProperty(nameData[1])) {
                filter[nameData[1]] = {};
            }

            if (!filter[nameData[1]].hasOwnProperty(nameData[2])) {
                filter[nameData[1]][nameData[2]] = {};
            }

            filter[nameData[1]][nameData[2]] = $input.prop('checked');

            if (filter[nameData[1]][nameData[2]]) {
                addFilterSelected($input);
            } else {
                removeFilterSelected($input);
            }
        });
        renderFilterOptions();
        updateFilterResult();
    }

    function renderFilterOptions () {
        $inputs.each(function (index, input) {
            const $input = $(input);
            const nameData = input.getAttribute('name').split('-');

            if (nameData.length !== 3) {
                throw new Error('некорректно указано значение атрибута name');
            }

            if (input.dataset.filterExtend) {
                const extendData = input.dataset.filterExtend.split('-');

                if (extendData.length !== 3) {
                    throw new Error('некорректно указано значение атрибута data-filter-extend');
                }

                let extendIsActive = false;
                const selectedExtend = [];

                for (let key in filter[extendData[1]]) {
                    if (filter[extendData[1]].hasOwnProperty(key)) {
                        if (filter[extendData[1]][key]) {
                            extendIsActive = true;
                            selectedExtend.push(key);
                        }
                        if (key === extendData[2]) {
                        }
                    }
                }

                if (selectedExtend.length) {
                    if (selectedExtend.filter(el => el === extendData[2]).length) {
                        $input.closest('label').show();
                    } else {
                        $input.prop('checked', false);
                        $input.closest('label').hide();

                        removeFilterSelected($input);
                    }
                } else {
                    $input.closest('label').show();
                }
            }
        });
    }

    function addFilterSelected($input) {
        const title = $input.next().html();
        const name = $input.attr('name');
        if ($filterSelected.find('.js-filter-selected-option[data-name="' + name + '"]').length) {
            return;
        }
        const html = `
            <div class="in-stock-filter__selected-item js-filter-selected-option" data-name="${ name }">
                <span>${ title }</span>
                <button><svg width="8" height="7" viewBox="0 0 8 7" fill="none"><path d="M1 .5l6 6m0-6l-6 6" stroke="currentColor"/></svg></button>
            </div>`;
        $filterSelected.append(html);
    }

    function removeFilterSelected($input) {
        const name = $input.attr('name');
        $filterSelected.find('.js-filter-selected-option[data-name="' + name + '"]').remove();
    }

    function updateFilterResult() {
        $resultItems.each(function (index, element) {
            element.classList.add('is-active');
        });

        for (let filterOption in filter) {
            if (filter.hasOwnProperty(filterOption)) {
                const filterSection = filter[filterOption];
                const selected = [];
                for (let section in filterSection) {
                    if (filterSection.hasOwnProperty(section)) {
                        if (filterSection[section]) {
                            selected.push(section);
                        }
                    }
                }

                if (selected.length) {
                    $resultItems.each(function (index, element) {
                        if (selected.indexOf(element.getAttribute('data-filter-' + filterOption)) === -1) {
                            element.classList.remove('is-active');
                        }
                    });
                }
            }
        }

        if ($('.js-filter-result-item.is-active').length) {
            $('#not-found').hide();
        } else {
            $('#not-found').show();
        }
    }

    function filterRender() {
        updateFilterData();
    }
    updateFilterData();

    // ---------------------------
    function initSlider() {
        if (!$(".js-slider").length) return false;

        if (typeof tns === 'undefined') {
            requestAnimationFrame(initSlider());
            return;
        }

        const slider = tns({
            container: ".js-slider",
            items: 1,
            controlsContainer: ".js-slider-controls",
            navContainer: ".js-slider-thumbs",
            navAsThumbnails: true,
            swipeAngle: false,
            // mouseDrag: true,
        });

        const $sliderControls = $('.js-slider-controls');
        const updateSliderControls = function () {
            if (window.matchMedia('(min-width: 601px').matches) {
                $sliderControls.hide();
            } else {
                $sliderControls.show();
            }
        }

        const slideCount = $('.js-slider-thumbs > li').length;
        if (slideCount > 1) {

            if (slideCount < 6) {
                updateSliderControls();
                window.addEventListener('resize', function () {
                    updateSliderControls();
                });
            }

            slider.events.on('indexChanged', function (info) {
                if (window.matchMedia('(min-width: 601px').matches) {
                    info.navItems[info.displayIndex - 1].scrollIntoView({block: "center", behavior: "smooth"});
                }
            });
        } else {
            $sliderControls.remove();
        }
    }

    initSlider();

    // ---------------------------
    $('.js-toggle-block-button').each(function (index, element) {
        const $toggleButton = $(element);
        const $toggleBlock = $toggleButton.closest('.js-toggle-block');
        const $toggleBlockContent = $toggleBlock.find('.js-toggle-block-content');
        const $toggleBlockContentParent = $toggleBlockContent.parent();

        if ($toggleBlockContentParent.innerHeight() >= $toggleBlockContent.innerHeight()) {
            $toggleBlock.addClass('is-active');
            $toggleButton.remove();
        } else {
            $toggleButton.on('click', function () {
                const INIT_HEIGHT = 300;
                const totalHeight = $toggleBlockContent.innerHeight();

                if (totalHeight > $toggleBlockContentParent.innerHeight()) {
                    $toggleBlockContentParent.animate({
                        height: totalHeight + 'px',
                    }, 500, function () {
                        $toggleBlock.addClass('is-active');
                    });
                } else {
                    $toggleBlockContentParent.animate({
                        height: INIT_HEIGHT + 'px',
                    }, 500, function () {
                        $toggleBlock.removeClass('is-active');
                    });
                }
            });
        }
    });

    $(document).on('click', '#availableInfo', function(e) {
        e.preventDefault();
        $('#available-info-modal').addClass('is-active');
    });

    $(document).on('click', '#available-info-modal .js-close-modal', function(e) {
        e.preventDefault();
        console.log('modal close test');
        $('#available-info-modal').removeClass('is-active');
    });
});